
import { Button } from "@/components/ui/button";
import { RefreshCw, Wand } from "lucide-react";
import { useState } from "react";

interface ImagePreviewProps {
  imageUrl: string;
  onRetake: () => void;
  onConfirm: () => void;
}

export function ImagePreview({ imageUrl, onRetake, onConfirm }: ImagePreviewProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    console.log("Confirm button clicked, processing image...");
    onConfirm();
    // Reset loading after a short delay to give visual feedback
    setTimeout(() => setIsLoading(false), 500);
  };

  return (
    <>
      <img 
        src={imageUrl} 
        alt="Captured" 
        className="w-full h-full object-cover animate-scale-in"
      />
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-4">
        <Button 
          variant="outline" 
          onClick={onRetake}
          className="bg-black/30 text-white border-white hover:bg-black/50"
          disabled={isLoading}
        >
          <RefreshCw size={18} className="mr-2" />
          <span>Retake</span>
        </Button>
        
        <Button 
          onClick={handleConfirm}
          className="bg-primary text-white hover:bg-primary/90"
          disabled={isLoading}
        >
          <Wand size={18} className={isLoading ? "animate-spin mr-2" : "mr-2"} />
          <span>{isLoading ? "Processing..." : "Use this image"}</span>
        </Button>
      </div>
    </>
  );
}

export default ImagePreview;
